module.exports = __webpack_public_path__ + "static/media/LeftoverSalmonreuniontourWorldCafeLive9-22-2011Handdrawn4colorscreenprint.6848cc74.webp";